import React, { useEffect, useState } from 'react';
import { Button } from '../../components/ui';
import AnnotatedVideoPlayer from '../../components/AnnotatedVideoPlayer';
import { reportAPI } from '../../services/api';

/**
 * Interview recording with proctoring flags, in a pop-up.
 *   <RecordingModal sessionId name subtitle onClose />
 */
export default function RecordingModal({ sessionId, name, subtitle, onClose }) {
  const [state, setState] = useState({ status: 'loading', data: null, error: null });

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [onClose]);

  useEffect(() => {
    let alive = true;
    setState({ status: 'loading', data: null, error: null });
    reportAPI.sessionRecording(sessionId)
      .then((res) => { if (alive) setState({ status: 'ready', data: res.data, error: null }); })
      .catch((err) => {
        const detail = err?.response?.data?.detail;
        if (alive) setState({ status: 'error', data: null, error: typeof detail === 'string' ? detail : 'The recording could not be loaded.' });
      });
    return () => { alive = false; };
  }, [sessionId]);

  const title = name ? `Recording · ${name}` : 'Interview recording';
  return (
    <div className="wz-report-scrim" role="dialog" aria-modal="true" aria-label={title}>
      <div className="wz-report-box wz-recbox">
        <div className="wz-report-head">
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <span style={{ fontWeight: 600, fontSize: 15 }}>{title}</span>
            <span className="wz-sub wz-ellipsis" style={{ fontSize: 12 }}>{subtitle || 'Video with proctoring flags'}</span>
          </div>
          <Button iconOnly icon="x" aria-label="Close" onClick={onClose} />
        </div>
        <div style={{ padding: 16, overflowY: 'auto' }}>
          {state.status === 'loading' && <p className="wz-sub" style={{ textAlign: 'center', padding: 40 }}>Loading recording…</p>}
          {state.status === 'error' && (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <p style={{ fontWeight: 600 }}>No recording to show.</p>
              <p className="wz-sub">{state.error}</p>
            </div>
          )}
          {state.status === 'ready' && <AnnotatedVideoPlayer parts={state.data.parts} events={state.data.events} />}
        </div>
      </div>
    </div>
  );
}
